import api from "../../store/services/api";

// Cost Category API calls
export const getCostCategories = async (params) =>
  await api.get("/delivery-center/cost-categories/", { params });

export const getCostCategoryById = async (categoryId) =>
  await api.get(`/delivery-center/cost-categories/${categoryId}/`);

export const createCostCategory = async (categoryData) =>
  await api.post("/delivery-center/cost-categories/", categoryData, {
    headers: { "Content-Type": "application/json" },
  });

export const updateCostCategory = async (categoryId, categoryData) =>
  await api.put(
    `/delivery-center/cost-categories/${categoryId}/`,
    categoryData,
    {
      headers: { "Content-Type": "application/json" },
    }
  );

export const deleteCostCategory = async (categoryId) =>
  await api.delete(`/delivery-center/cost-categories/${categoryId}/`);

// Supplier API calls
export const getSuppliers = async (params) =>
  await api.get("/delivery-center/suppliers/", { params });

export const getSupplierById = async (supplierId) =>
  await api.get(`/delivery-center/suppliers/${supplierId}/`);

export const createSupplier = async (supplierData) =>
  await api.post("/delivery-center/suppliers/", supplierData, {
    headers: { "Content-Type": "application/json" },
  });

export const updateSupplier = async (supplierId, supplierData) =>
  await api.put(`/delivery-center/suppliers/${supplierId}/`, supplierData, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteSupplier = async (supplierId) =>
  await api.delete(`/delivery-center/suppliers/${supplierId}/`);

// Cost API calls
export const getCosts = async (params) =>
  await api.get("/delivery-center/costs/", { params });

export const getCostById = async (costId) =>
  await api.get(`/delivery-center/costs/${costId}/`);

export const createCost = async (costData) =>
  await api.post("/delivery-center/costs/", costData, {
    headers: { "Content-Type": "application/json" },
  });

export const createCostBatch = async (costData) =>
  await api.post("/delivery-center/costs/batch_create/", costData, {
    headers: { "Content-Type": "application/json" },
  });

export const updateCost = async (costId, costData) =>
  await api.put(`/delivery-center/costs/${costId}/`, costData, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteCost = async (costId) =>
  await api.delete(`/delivery-center/costs/${costId}/`);

// Summary reports
export const getCostSummaryByCategory = async (params) =>
  await api.get("/delivery-center/costs/summaryByCategory/", { params });

export const getCostSummaryByWeek = async (params) =>
  await api.get("/delivery-center/costs/summaryByWeek/", { params });

// PHONE NUMBERS
export const getBotPhoneNumbers = async (params) =>
  await api.get("/delivery-center/phone-numbers/", { params });

export const getBotPhoneNumberById = async (botPhoneId) =>
  await api.get(`/delivery-center/phone-numbers/${botPhoneId}/`);

export const createBotPhoneNumber = async (botPhoneData) =>
  await api.post("/delivery-center/phone-numbers/", botPhoneData, {
    headers: { "Content-Type": "application/json" },
  });

export const updateBotPhoneNumber = async (botPhoneId, botPhoneData) =>
  await api.put(`/delivery-center/phone-numbers/${botPhoneId}/`, botPhoneData, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteBotPhoneNumber = async (botPhoneId) =>
  await api.delete(`/delivery-center/phone-numbers/${botPhoneId}/`);

// FISCAL DOCUMENTS (raw WhatsApp-uploaded notes, pre-OCR audit view)
export const getFiscalDocuments = async (params) =>
  await api.get("/delivery-center/fiscal-documents/", { params });

export const getFiscalDocumentById = async (documentId) =>
  await api.get(`/delivery-center/fiscal-documents/${documentId}/`);

// Service object with all functions
const DeliveryCenterCostsService = {
  // Cost Categories
  getCostCategories,
  getCostCategoryById,
  createCostCategory,
  updateCostCategory,
  deleteCostCategory,

  // Suppliers
  getSuppliers,
  getSupplierById,
  createSupplier,
  updateSupplier,
  deleteSupplier,

  // Costs
  getCosts,
  getCostById,
  createCost,
  createCostBatch,
  updateCost,
  deleteCost,

  // PHONE NUMBERS
  getBotPhoneNumbers,
  getBotPhoneNumberById,
  createBotPhoneNumber,
  updateBotPhoneNumber,
  deleteBotPhoneNumber,

  // FISCAL DOCUMENTS (raw OCR records)
  getFiscalDocuments,
  getFiscalDocumentById,

  // Summary reports
  getCostSummaryByCategory,
  getCostSummaryByWeek,
};

export default DeliveryCenterCostsService;
